import React, { useEffect } from 'react'
import Navigation from '../partials/Navigation'
import Greeting from '../components/Greeting'
import BookNowForm from '../components/BookNowForm'
import ContentBanner from '../components/ContentBanner'
import SocialLink from '../components/SocialLink'
import useTransferList from '../hooks/useTransferList'
import UpcomingBookingsList from '../components/UpcomingBookingsList'
import Page from '../components/Page'

const Home = () => {
  const upcomingTransfers = useTransferList('future')

  const bannerOne = {
    title: 'Refer a friend',
    content:
      "Coming soon! £10 off your next booking when your referred friend books with us. <a href='/terms-and-conditions/#refer-a-friend'>T&Cs apply.</a>",
    bg: 'car',
    link: {
      type: 'btn' as const,
      text: 'Send an invite',
      url: '/',
    },
  }

  const bannerTwo = {
    title: 'Exclusive Offers',
    content:
      "Very soon, you will begin receiving your exclusive offers for worldwide airport transfers. We'll keep you posted!",
    bg: 'airport',
    link: {
      type: 'arrow' as const,
      url: '/',
    },
  }

  if (upcomingTransfers.isLoading || upcomingTransfers.response.transfers.length === 0) {
    return (
      <Page className="bg-light-blue">
        <Navigation />

        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 pt-4 pt-lg-5">
              <Greeting />
              <BookNowForm size="large" />

              <div className="row mt-5">
                <div className="col-12 col-lg-6">
                  <ContentBanner content={bannerOne} />
                </div>
                <div className="col-12 col-lg-6">
                  <ContentBanner content={bannerTwo} />
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                  <SocialLink
                    text="Join us on Facebook"
                    link="https://www.facebook.com/myairportcars"
                    icon="facebook"
                  />
                </div>
                <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                  <SocialLink text="Follow us on Twitter" link="https://twitter.com/@myairportcars" icon="twitter" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Page>
    )
  }

  return (
    <Page className="bg-light-blue">
      <Navigation />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 col-lg-10 pt-4 pt-lg-5">
            <Greeting />

            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="d-lg-none">
                  <BookNowForm size="small" />
                </div>
                {upcomingTransfers.response ? (
                  <>
                    <UpcomingBookingsList transfers={upcomingTransfers.response.transfers} />
                  </>
                ) : null}
                <div className="mt-4">
                  <ContentBanner content={bannerOne} />
                </div>
                <div className="mt-4">
                  <SocialLink
                    text="Join us on Facebook"
                    link="https://www.facebook.com/myairportcars"
                    icon="facebook"
                  />
                </div>
                <div className="mt-4">
                  <SocialLink text="Follow us on Twitter" link="https://twitter.com/@myairportcars" icon="twitter" />
                </div>
              </div>
              <div className="col-12 col-lg-6">
                <div className="d-none d-lg-block">
                  <BookNowForm size="small" />
                </div>
                <div className="mt-4">
                  <ContentBanner content={bannerTwo} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Page>
  )
}

export default Home
